import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocsFolderSearch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m87.818 53.883-.657 40.764a5.249 5.249 0 0 1-5.24 5.158H23.416a5.241 5.241 0 0 1-5.24-5.323l.648-40.443a5.248 5.248 0 0 1 5.24-5.158H82.89a4.934 4.934 0 0 1 4.928 5.01v-.008Z"
        fill="#599F40"
      />
      <path
        d="M80.943 20.125a9.854 9.854 0 0 1 9.857 9.856H41.518a9.854 9.854 0 0 0-9.856-9.856h49.281Z"
        fill="#E2E8F0"
      />
      <path
        d="M31.662 20.125a9.854 9.854 0 0 0-9.856 9.856V89.12h49.281V29.98a9.854 9.854 0 0 1 9.856-9.856H31.662Z"
        fill="#F1F5F9"
      />
      <path
        d="M32.738 30.14a2.273 2.273 0 0 1 2.255.003c.328.188.62.465.826.822l.001.002 3.466 5.963.002.003a2.253 2.253 0 0 1-.828 3.08 2.274 2.274 0 0 1-3.093-.82l-.003-.005-1.508-2.599-1.502 2.59-.003.004a2.273 2.273 0 0 1-3.092.822 2.252 2.252 0 0 1-.828-3.08l.001-.003 3.467-5.955.001-.002.006.003c.206-.358.499-.637.826-.826l.006-.003Zm2.05 4.867 1.958 3.373.08.11c.21.235.56.295.835.137a.652.652 0 0 0 .24-.895l-2.35-4.044-.763 1.319Zm-4.972 2.715.001.001a.653.653 0 0 0 .24.896.674.674 0 0 0 .915-.246l1.955-3.37-.761-1.316-2.35 4.035Zm3.466-5.95-.001.001-.038.076a.637.637 0 0 0 .036.568l.004.005.576.996.577-.995a.639.639 0 0 0 .001-.65v-.002l-.004-.005a.649.649 0 0 0-.239-.238.676.676 0 0 0-.668.004.647.647 0 0 0-.233.234l-.987-.563.976.57Z"
        fill="#78B441"
      />
      <path
        d="M63.432 68.606a.8.8 0 0 1 0 1.6H28.935a.8.8 0 1 1 0-1.6h34.497Zm0-4.927a.8.8 0 0 1 0 1.6H28.935a.8.8 0 1 1 0-1.6h34.497Zm0-4.93a.8.8 0 0 1 0 1.601H28.935a.8.8 0 0 1 0-1.6h34.497Zm0-4.927a.8.8 0 0 1 0 1.6H28.935a.8.8 0 1 1 0-1.6h34.497Zm0-4.929a.8.8 0 0 1 0 1.601H28.935a.8.8 0 0 1 0-1.6h34.497Zm0-4.927a.8.8 0 0 1 0 1.6H28.935a.8.8 0 1 1 0-1.6h34.497Zm0-4.928a.8.8 0 1 1 0 1.6H43.72a.8.8 0 0 1 0-1.6h19.713Zm0-4.929a.8.8 0 0 1 0 1.6H43.72a.8.8 0 0 1 0-1.6h19.713Zm0-4.928a.8.8 0 1 1 0 1.6H43.72a.8.8 0 0 1 0-1.6h19.713Z"
        fill="#B3C0D0"
      />
      <path
        d="M70.287 29.981c0-5.887 4.77-10.656 10.656-10.656a.8.8 0 1 1 0 1.6 9.054 9.054 0 0 0-9.056 9.056.8.8 0 1 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M17.395 96.01a4.93 4.93 0 0 0 4.863 4.115h59.556a5.416 5.416 0 0 1-5.347-4.526l-5.265-28.304a9.853 9.853 0 0 0-9.725-8.238H40.262l-.953-5.733a4.923 4.923 0 0 0-4.863-4.123H14.931c-3.072 0-5.388 2.776-4.854 5.79l7.318 41.019Z"
        fill="#78B441"
      />
      <path
        d="M81.814 99.796H25.42c-3.343 0-5.01.395-6.99-1.823-2.127-2.259-.772-6.563 3.014-6.563h10.037c3.154 0 6.12-1.478 8.017-4l2.004-2.669 3.729 3.729a10.04 10.04 0 0 0 7.096 2.94h19.581c2.21 0 4.09 1.594 4.452 3.77a5.521 5.521 0 0 0 5.446 4.616h.008Z"
        fill="#599F40"
      />
      <path
        d="M34.454 48.073a5.73 5.73 0 0 1 5.653 4.784l.84 5.072h20.538c5.207 0 9.652 3.757 10.511 8.892L77.27 95.19l.003.017c.432 2.621 3.067 4.406 5.841 3.585h.001c1.88-.557 3.163-2.39 3.163-4.416a.8.8 0 0 1 1.601 0c0 2.587-1.586 5.018-4.067 5.872l-.243.078c-3.709 1.098-7.278-1.298-7.872-4.844l-5.273-28.37-.003-.014a9.053 9.053 0 0 0-8.936-7.57H40.27a.8.8 0 0 1-.79-.668l-.952-5.741a4.13 4.13 0 0 0-4.074-3.447H18.906a.8.8 0 1 1 0-1.6h15.548ZM40.945 84.176a.8.8 0 0 1 1.13 0l5.02 5.018a.8.8 0 1 1-1.132 1.131l-5.018-5.019a.8.8 0 0 1 0-1.13Z"
        fill="#0F172A"
      />
      <path
        d="m87.715 65.339 22.019 18.359a4.857 4.857 0 1 1-6.508 7.199l-20.482-20.06 4.971-5.498Z"
        fill="#007A5F"
      />
      <path d="m94.636 71.109.653 12.015-12.545-12.286 4.971-5.5 6.92 5.77Z" fill="#00664F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.183 76.741c9.939 5.089 22.12 1.156 27.21-8.782 5.088-9.939 1.156-22.121-8.783-27.21-9.94-5.088-22.121-1.157-27.21 8.782-5.088 9.94-1.156 22.121 8.783 27.21Z"
        fill="#007A5F"
      />
      <path
        d="M90.218 59.078c0 8.002-6.487 14.489-14.49 14.489-8.001 0-14.488-6.487-14.488-14.49 0-8.001 6.487-14.488 14.489-14.488s14.489 6.487 14.489 14.489Z"
        fill="#CAE8DF"
      />
      <path
        d="M63.81 59.078c0-6.583 5.336-11.92 11.918-11.92a.8.8 0 1 1 0 1.6c-5.698 0-10.319 4.62-10.319 10.32a.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M60.44 59.078c0-8.444 6.845-15.29 15.289-15.29a.8.8 0 1 1 0 1.6c-7.56 0-13.69 6.13-13.69 13.69s6.13 13.69 13.69 13.69a.8.8 0 1 1 0 1.599c-8.444 0-15.29-6.845-15.29-15.29Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocsFolderSearch)
